import Breadcrumb from "components/Common/Breadcrumb"
import moment from "moment"
import React, { useEffect, useState } from "react"
import { FaChevronLeft, FaChevronRight, FaEye, FaPlus } from "react-icons/fa6"
import {
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Table,
} from "reactstrap"
import Swal from "sweetalert2"
import { fetchData, FetchPutData } from "utils/Common_api_functions"

const initialQueries = [
  {
    id: 1,
    customerName: "John Doe",
    email: "john.doe@example.com",
    contactNumber: "+1 555-123-4567",
    queryType: "Questions about the 5K plan.",
    status: "Open",
    description:
      "Customer wants to understand the structure of the 5K plan before subscribing.",
    createdAt: "2025-08-01T10:30:00Z",
  },
  {
    id: 2,
    customerName: "Emily Smith",
    email: "emily.smith@example.com",
    contactNumber: "+1 555-234-5678",
    queryType: "Help with app journey.",
    status: "In Progress",
    description:
      "Having trouble navigating between training modules in the mobile app.",
    createdAt: "2025-08-03T11:15:00Z",
  },
  {
    id: 3,
    customerName: "Michael Johnson",
    email: "michael.johnson@example.com",
    contactNumber: "+1 555-345-6789",
    queryType: "Interest in other training plans.",
    status: "Closed",
    description:
      "Wants to explore advanced training plans after completing the 10K.",
    createdAt: "2025-08-05T09:00:00Z",
  },
  {
    id: 4,
    customerName: "Sophia Lee",
    email: "sophia.lee@example.com",
    contactNumber: "+1 555-456-7890",
    queryType: "Corporate sponsorship.",
    status: "Open",
    description:
      "Reached out to discuss potential sponsorship opportunities for employees.",
    createdAt: "2025-08-06T16:45:00Z",
  },
  {
    id: 5,
    customerName: "David Brown",
    email: "david.brown@example.com",
    contactNumber: "+1 555-567-8901",
    queryType: "Other queries.",
    status: "Closed",
    description:
      "General feedback regarding payment methods and invoice generation.",
    createdAt: "2025-08-07T13:10:00Z",
  },
]

const UserQuery = () => {
  const [loading, setloading] = useState(false)

  const [querys, setQuerys] = useState([])
  const [selectedQuery, setSelectedQuery] = useState(null)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [page, setPage] = useState(1)
  const [itemsPerPage] = useState(10)

  const [data, setData] = useState([])
  const [searchString, setSearchString] = useState("")

  useEffect(() => {
    if (searchString !== "") {
      const filteredData = data.filter(
        item =>
          item.user?.name.toLowerCase().includes(searchString.toLowerCase()) ||
          item.user?.email.toLowerCase().includes(searchString.toLowerCase()) ||
          item.queryType.toLowerCase().includes(searchString.toLowerCase())
      )
      setQuerys(filteredData)
      setPage(1)
    } else {
      setQuerys(data)
    }
  }, [searchString, data])

  useEffect(() => {
    getQueryData()
  }, [])

  async function getQueryData() {
    const APIData = await fetchData(setloading, "user/query/all")

    if (APIData?.success) {
      setQuerys(APIData?.queries)
      setData(APIData?.queries)
    }
  }

  const totalPages = Math.ceil(querys.length / itemsPerPage)
  const finalData = querys.slice((page - 1) * itemsPerPage, page * itemsPerPage)

  const changePage = pageNumber => {
    if (pageNumber > 0 && pageNumber <= totalPages) {
      setPage(pageNumber)
      window.scrollTo(0, 0)
    }
  }

  async function handleStatusUpdate(status, queryid) {
    const APIData = await FetchPutData(setloading, "user/query", queryid, {
      queryStatus: status,
    })

    if (APIData?.data?.success) {
      Swal.fire({
        title: "Query status updated Successfully",
        icon: "success",
      })
      setIsModalOpen(false)
      getQueryData()
    } else {
      Swal.fire({
        title: "Something Went Wrong",
        text: APIData?.response?.data?.message,
        icon: "error",
      })
    }
  }

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumb title="" breadcrumbItem="User Query" />

        <Row>
          <Col lg="12">
            <Card>
              <CardBody>
                <div className="d-flex justify-content-between align-items-center">
                  <h4 className="text-black fw-bold ps-1 mb-0">User Query</h4>
                  <div className="d-flex gap-3">
                    <div className="form-group">
                      <Input
                        placeholder="Search User Query"
                        value={searchString}
                        onChange={e => setSearchString(e.target.value)}
                      />
                    </div>
                  </div>
                </div>

                <div className="mt-3">
                  <Table responsive bordered className="rounded-3">
                    <thead className="table-primary text-dark">
                      <tr>
                        <th>Sr No.</th>
                        <th>Customer Name</th>
                        <th>Email</th>
                        <th>Query Type</th>
                        <th>Status</th>
                        <th>Created At</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {finalData.map((query, index) => (
                        <tr key={query.id}>
                          <td>{(page - 1) * itemsPerPage + index + 1}</td>
                          <td>{query?.user?.name}</td>

                          <td>{query?.user?.email}</td>
                          <td>{query?.queryType}</td>
                          <td>
                            {query?.queryStatus === "Pending" && (
                              <span className="badge bg-primary p-2 fs-6">
                                {query.queryStatus}
                              </span>
                            )}
                            {query?.queryStatus === "In-Progress" && (
                              <span className="badge bg-success p-2 fs-6">
                                {query.queryStatus}
                              </span>
                            )}
                            {query?.queryStatus === "Closed" && (
                              <span className="badge bg-dark p-2 fs-6">
                                {query.queryStatus}
                              </span>
                            )}
                          </td>

                          <td>
                            {moment(query?.createdAt).format("DD-MM-YYYY")}
                          </td>
                          <td>
                            <button
                              className="btn btn-sm btn-primary me-2"
                              onClick={() => {
                                setSelectedQuery(query)
                                setIsModalOpen(true)
                              }}
                            >
                              <FaEye size={12} />
                            </button>
                          </td>
                        </tr>
                      ))}
                      {finalData?.length === 0 && (
                        <tr>
                          <td colSpan={7} className="text-center">
                            No Data Found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>

                <div className="d-flex justify-content-between align-items-center my-2 px-2">
                  <p className="mb-0">
                    Showing {finalData.length} out of {querys.length} User
                    Queries.
                  </p>
                  <div className="d-flex flex-wrap">
                    <div
                      className="bd-number-pagination me-1"
                      onClick={() => changePage(page - 1)}
                      style={{ cursor: "pointer" }}
                    >
                      <FaChevronLeft />
                    </div>
                    {[...Array(totalPages)].map((_, i) => {
                      const pageIndex = i + 1
                      return (
                        <div
                          key={pageIndex}
                          className={`bd-number-pagination me-1 ${
                            page === pageIndex ? "activepage" : ""
                          }`}
                          onClick={() => changePage(pageIndex)}
                          style={{ cursor: "pointer" }}
                        >
                          {pageIndex < 10 ? "0" + pageIndex : pageIndex}
                        </div>
                      )
                    })}
                    <div
                      className="bd-number-pagination"
                      onClick={() => changePage(page + 1)}
                      style={{ cursor: "pointer" }}
                    >
                      <FaChevronRight />
                    </div>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>

      <Modal
        isOpen={isModalOpen}
        toggle={() => setIsModalOpen(!isModalOpen)}
        centered
        size="lg"
      >
        <ModalHeader toggle={() => setIsModalOpen(!isModalOpen)}>
          Customer Query
        </ModalHeader>
        <ModalBody>
          {selectedQuery ? (
            <Table bordered>
              <tbody>
                <tr>
                  <th>Query ID</th>
                  <td>{selectedQuery._id}</td>
                </tr>
                <tr>
                  <th>Customer Name</th>
                  <td>{selectedQuery?.user?.name}</td>
                </tr>
                <tr>
                  <th>Contact Email</th>
                  <td>{selectedQuery?.user?.email}</td>
                </tr>
                <tr>
                  <th>Query Type</th>
                  <td>{selectedQuery.queryType}</td>
                </tr>
                <tr>
                  <th>Description</th>
                  <td>{selectedQuery.queryDescription}</td>
                </tr>
                <tr>
                  <th>Created At</th>
                  <td>
                    {moment(selectedQuery.createdAt).format("DD-MM-YYYY HH:MM")}
                  </td>
                </tr>
                <tr>
                  <th>Status</th>
                  <td>
                    {selectedQuery?.queryStatus === "Closed" ? (
                      <span className="text-danger fw-bold">{selectedQuery?.queryStatus}</span>
                    ) : (
                      <Input
                        type="select"
                        className="form-select w-auto"
                        value={selectedQuery?.queryStatus}
                        onChange={e =>
                          handleStatusUpdate(e.target.value, selectedQuery?._id)
                        }
                      >
                        <option value="Pending">Pending</option>
                        <option value="In-Progress">In-Progress</option>
                        <option value="Closed">Closed</option>
                      </Input>
                    )}
                  </td>
                </tr>
              </tbody>
            </Table>
          ) : (
            <p>No query selected.</p>
          )}
        </ModalBody>
      </Modal>
    </div>
  )
}

export default UserQuery
